import { Link } from "gatsby";
import React, { useState } from "react";
import { FaPlayCircle } from "@react-icons/all-files/fa/FaPlayCircle";
import { FaSpotify } from "@react-icons/all-files/fa/FaSpotify";
import "./podcast-header.scss";
import Button from "../../ui/button/Button";
import Separator from "../../ui/separator/Separator";
import ShareModal from "../../molecules/ShareModal/ShareModal";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { FaShare } from "react-icons/fa";

interface IPodcastHeaderProps {
  title: string;
  text: string;
  imgUrl: string;
  id: string;
}

const PodcastHeader = (props: IPodcastHeaderProps) => {
  const compClass = "o-podcastHeader";

  const [isModalVisible, setIsModalVisible] = useState(false);
  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  return (
    <section
      className={compClass}
      style={{
        backgroundImage: `url(${props.imgUrl})`,
      }}
    >
      <div className={`${compClass}__wrapper`}>
        <div className={`${compClass}__column`}>
          <p className={`${compClass}__breadcum`}>
            <Link to="/">Inicio</Link> / Podcasts
          </p>
          <span className={`${compClass}__tag`}>podcast</span>
          <h1 className={`${compClass}__title`}>{props.title}</h1>
          <p className={`${compClass}__excerpt`}>{props.text}</p>
          <div className={`${compClass}__actions`}>
            <Button
              onClick={() =>
                window.open("https://open.spotify.com/episode/" + props.id)
              }
              title="Escuchar este podcast en Spotify."
            >
              <FaPlayCircle className={`${compClass}__buttonIcon`} />
              Escuchar ahora
            </Button>
            <div className={`${compClass}__subscribe`}>
              <span style={{ marginRight: "2rem" }}>Suscríbete:</span>{" "}
              <Link to="https://open.spotify.com/show/2EscmnqVNqCx2SWMWbbB2W" target="_blank" rel="noreferrer">
                <FaSpotify /> <span style={{ marginLeft: ".3rem" }}>SPOTIFY</span>
              </Link>
            </div>
          </div>
          <Separator />
          <div className={`${compClass}__share`} onClick={toggleModal} style={{cursor: "pointer"}}>
            <FaShare /> <span style={{ marginLeft: ".3rem" }}>Compartir</span>
          </div>
          <ShareModal
            open={isModalVisible}
            onClose={toggleModal}
            gtmClass={`gtm${normalizeTwoWords(
              props.title
            )}Articulo${normalizeTwoWords(props.title)}Compartir`}
          />
        </div>
      </div>
    </section>
  );
};

export default PodcastHeader;
